import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
query lunchControlsWithPagination($page: Int, $perPage: Int, $filters: FiltersLunchControl) {
  lunchControlsWithPagination(page: $page, first: $perPage, filters: $filters){
    paginatorInfo {
      currentPage
      count
      hasMorePages
      perPage
      total
    }
    data {
      id
      employee_id
      employee {
        id
        name
        last_name
        mothers_last_name
        document_type
        document_number
      }
      lunch_rate_id
      lunchRate {
        id
        name
        price
      }
      date
    }
  }
}
`

const GET_ALL = gql`
  query lunchControls ($filters: FiltersLunchControl) {
    lunchControls (filters: $filters) {
      id
      employee_id
      employee {
        id
        name
        last_name
        mothers_last_name
        document_type
        document_number
      }
      lunch_rate_id
      lunchRate {
        id
        name
        price
      }
      date
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createLunchControl ($input: LunchControlForm!) {
    createLunchControl (input: $input) {
      id
    }
  }
`

const UPDATE = gql`
  mutation updateLunchControl ($id: ID!, $input: LunchControlForm!) {
    updateLunchControl (id: $id, input: $input) {
      id
    }
  }
`

const DELETE = gql`
  mutation deleteLunchControl ($id: ID!) {
    deleteLunchControl(id: $id) { 
      id
    }
  }
`

const VALIDATE_LUNCH = gql`
  mutation validateLunchControl($id: ID, $input: LunchControlForm!) {
    validateLunchControl (id: $id, input: $input) {
      success
      msgError
    }
  }
`

export {
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE,
    GET_ALL,
    VALIDATE_LUNCH
}
